<template>
  <v-dialog v-model="visible" width="'90%'" :fullscreen="$vuetify.breakpoint.smAndDown" persistent scrollable>
    <v-card class="rounded-xl">
      <v-card-title>
        <div v-if="veranstaltung.titel">{{ veranstaltung.titel }}</div>
        <v-spacer></v-spacer>
        <v-btn icon @click="close()"><v-icon>close</v-icon></v-btn>
      </v-card-title>
      <v-divider class="mb-2"></v-divider>
      <v-card-text class="px-0">
        <v-row no-gutters>
          <v-col cols="12" md="5" class="px-1">
            <v-card outlined height="100%">
              <v-row class="ma-2" no-gutters>
                <v-col cols="12" class="pa-1">
                  <v-text-field dense hide-details outlined label="Titel" v-model="veranstaltung.titel"></v-text-field>
                </v-col>
                <v-col cols="8" md="3" class="pa-1">
                  <v-menu
                    ref="veranstaltung.vonDatum"
                    v-model="menu1"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    :return-value.sync="date"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        dense
                        hide-details
                        outlined
                        v-model="formatVonDatum"
                        label="Beginn"
                        readonly
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      reactive
                      @change="changeVonDatum"
                      prev-icon="keyboard_arrow_left"
                      next-icon="keyboard_arrow_right"
                      v-model="veranstaltung.vonDatum"
                      locale="de-de"
                      first-day-of-week="1"
                      @input="menu1 = false"
                      no-title
                      scrollable
                    >
                    </v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="4" md="3" class="pa-1">
                  <v-menu
                    ref="veranstaltung.vonZeit"
                    v-model="menu2"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    :return-value.sync="date"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        dense
                        hide-details
                        outlined
                        v-model="veranstaltung.vonZeit"
                        label="Um"
                        readonly
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-time-picker
                      :allowed-minutes="allowedMinutes"
                      format="24hr"
                      prev-icon="keyboard_arrow_left"
                      next-icon="keyboard_arrow_right"
                      v-model="veranstaltung.vonZeit"
                      locale="de-de"
                      first-day-of-week="1"
                      scrollable
                    >
                    </v-time-picker>
                  </v-menu>
                </v-col>
                <v-col cols="8" md="3" class="pa-1">
                  <v-menu
                    ref="veranstaltung.bisDatum"
                    v-model="menu3"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    :return-value.sync="date"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        dense
                        hide-details
                        outlined
                        v-model="formatBisDatum"
                        label="Ende"
                        readonly
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      prev-icon="keyboard_arrow_left"
                      next-icon="keyboard_arrow_right"
                      v-model="veranstaltung.bisDatum"
                      locale="de-de"
                      first-day-of-week="1"
                      @input="menu3 = false"
                      no-title
                      scrollable
                    >
                    </v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="4" md="3" class="pa-1">
                  <v-menu
                    ref="veranstaltung.bisZeit"
                    v-model="menu4"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    :return-value.sync="date"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        dense
                        hide-details
                        outlined
                        v-model="veranstaltung.bisZeit"
                        label="Um"
                        readonly
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-time-picker
                      :allowed-minutes="allowedMinutes"
                      format="24hr"
                      prev-icon="keyboard_arrow_left"
                      next-icon="keyboard_arrow_right"
                      v-model="veranstaltung.bisZeit"
                      locale="de-de"
                      first-day-of-week="1"
                      scrollable
                    >
                    </v-time-picker>
                  </v-menu>
                </v-col>
                <v-col cols="12" class="pa-1">
                  <v-autocomplete
                    dense
                    hide-details
                    outlined
                    :items="kleiderordnungen"
                    label="Kleiderordnung"
                    v-model="veranstaltung.kleiderordnung"
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12" class="pa-1">
                  <v-text-field dense hide-details outlined label="Ort" v-model="veranstaltung.ort"></v-text-field>
                </v-col>
                <v-col cols="6" class="pa-1">
                  <v-text-field
                    dense
                    hide-details
                    outlined
                    messages="o/ho"
                    label="Kategorie"
                    v-model="veranstaltung.kategorie"
                  ></v-text-field>
                </v-col>
                <v-col cols="6" class="pa-1">
                  <v-text-field dense hide-details outlined label="Preis" v-model="veranstaltung.preis"></v-text-field>
                </v-col>
                <v-col cols="6" class="pa-1">
                  <v-menu
                    ref="veranstaltung.anmeldungBis"
                    v-model="menu5"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    :return-value.sync="date"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        clearable
                        dense
                        hide-details
                        outlined
                        v-model="veranstaltung.anmeldungBis"
                        label="Anmeldung bis"
                        readonly
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      prev-icon="keyboard_arrow_left"
                      next-icon="keyboard_arrow_right"
                      v-model="veranstaltung.anmeldungBis"
                      locale="de-de"
                      first-day-of-week="1"
                      @input="menu5 = false"
                      no-title
                      scrollable
                    >
                    </v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="6" class="pa-1">
                  <v-select
                    dense
                    hide-details
                    outlined
                    :items="itemsKalender"
                    label="Kalender"
                    v-model="veranstaltung.kalender"
                  ></v-select>
                </v-col>
                <v-col cols="12" class="pa-1">
                  <v-autocomplete
                    dense
                    hide-details
                    hint="Pflichtanmeldungen können nicht mehr bearbeitet werden!"
                    disabled
                    multiple
                    outlined
                    dele
                    deletable-chips
                    chips
                    clearable
                    clear-icon="close"
                    :items="gruppen"
                    label="Pflichtanmeldungen"
                    v-model="veranstaltung.pflichtanmeldungen"
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12" class="pa-1">
                  <v-textarea
                    dense
                    hide-details
                    outlined
                    auto-grow
                    rows="10"
                    label="Bemerkung"
                    v-model="veranstaltung.bemerkung"
                  ></v-textarea>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
          <v-col cols="12" md="3" class="px-1">
            <v-card outlined height="100%">
              <v-simple-table dense fixed-header height="calc(100vh - 364px)">
                <thead>
                  <tr>
                    <th>Anmeldungen ({{ veranstaltung.anmeldungen ? veranstaltung.anmeldungen.length : 0 }})</th>
                    <th width="20px"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in veranstaltung.anmeldungen" :key="index">
                    <td>{{ $filters.user(item, bbrbbr) }}</td>
                    <td>
                      <v-btn icon @click="anmeldungEntfernen(item)"><v-icon>delete</v-icon></v-btn>
                    </td>
                  </tr>
                </tbody>
              </v-simple-table>
              <v-divider></v-divider>
              <v-card-actions>
                <v-autocomplete
                  dense
                  hide-details
                  outlined
                  :items="bundesbruder"
                  label="Bbr hinzufügen"
                  v-model="neueAnmeldung"
                  @click:append-outer="anmeldungHinzufuegen"
                  append-outer-icon="add"
                ></v-autocomplete>
              </v-card-actions>
            </v-card>
          </v-col>
          <v-col cols="12" md="4" class="px-1">
            <v-card outlined height="100%">
              <v-simple-table dense fixed-header height="calc(100vh - 364px)">
                <thead>
                  <tr>
                    <th>
                      Weitere Anmeldungen ({{
                        veranstaltung.weitereAnmeldungen ? veranstaltung.weitereAnmeldungen.length : 0
                      }})
                    </th>
                    <th width="20px"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in veranstaltung.weitereAnmeldungen" :key="index">
                    <td>{{ item.name }} ({{ $filters.user(item.angemeldetVon, bbrbbr) }})</td>
                    <td>
                      <v-btn icon @click="anmeldungEntfernenWeitere(item)"><v-icon>delete</v-icon></v-btn>
                    </td>
                  </tr>
                </tbody>
              </v-simple-table>
              <v-divider></v-divider>
              <v-card-actions>
                <v-autocomplete
                  dense
                  hide-details
                  outlined
                  :items="bundesbruder"
                  label="Zugehörigen Bbr"
                  v-model="neueAnmeldungWeitere.angemeldetVon"
                ></v-autocomplete>
                <v-text-field
                  dense
                  hide-details
                  outlined
                  label="Name der Person"
                  v-model="neueAnmeldungWeitere.name"
                  @click:append-outer="anmeldungHinzufuegenWeitere"
                  append-outer-icon="add"
                ></v-text-field>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions class="mb-6 mb-md-0">
        <v-btn icon @click="showDeleteVeranstaltung = true"><v-icon>delete</v-icon></v-btn>
        <v-spacer></v-spacer>
        <v-btn rounded text @click="close()">Abbrechen</v-btn>
        <v-btn
          rounded
          class="primary"
          text
          :disabled="veranstaltung.kalender === '' || veranstaltung.titel === '' || formatVonDatum === ''"
          @click="saveVeranstaltung()"
          >Speichern</v-btn
        >
      </v-card-actions>
    </v-card>

    <dialogDelete
      :visible.sync="showDeleteVeranstaltung"
      title="Veranstaltung löschen"
      message="Willst du die Veranstaltung wirklich löschen? Dies kann nicht rückgängig gemacht werden."
      abbrechen="Abbrechen"
      weiter="Löschen"
      @closeTrue="deleteVeranstaltung()"
      @closeFalse="showDeleteVeranstaltung = false"
    >
    </dialogDelete>
  </v-dialog>
</template>

<script>
  export default {
    props: ["veranstaltung", "visible"],
    data() {
      return {
        kleiderordnungen: [
          "Gepflegt leger",
          "Gepflegt leger mit Hemd",
          "Kombination",
          "Kombination mit plenis coloribus",
          "Dunkler Anzug",
          "Dunkler Anzug mit plenis coloribus",
          "Abendgarderobe",
        ],
        gruppen: [
          { text: "Füxe", value: "Fux" },
          { text: "Aktive", value: "Aktiver" },
          { text: "Inaktive in loco", value: "Inaktiver in loco" },
          { text: "Inaktive extra locum", value: "Inaktiver extra locum" },
        ],
        date: "",
        menu1: "",
        menu2: "",
        menu3: "",
        menu4: "",
        menu5: "",
        neueAnmeldung: "",
        neueAnmeldungWeitere: {},
        showDeleteVeranstaltung: false,
      };
    },
    computed: {
      bbrbbr() {
        return this.$store.state.bbrbbr.bbrbbr;
      },
      currentBbr() {
        return this.$getCurrentBbr();
      },
      bundesbruder() {
        let bbrbbr = [];
        this.$store.state.bbrbbr.bbrbbr.forEach((item) => {
          if (item.vulgo) {
            bbrbbr.push({
              value: item.id,
              text: item.nachname + ", " + item.vorname + " (" + item.vulgo + ")",
            });
          } else {
            bbrbbr.push({
              value: item.id,
              text: item.nachname + ", " + item.vorname,
            });
          }
        });
        return bbrbbr;
      },
      itemsKalender() {
        let kalender = [];
        this.$store.getters["einstellungen/einstellung"]("alleKalender").forEach((key) => {
          kalender.push({
            value: key.name,
            text: key.name,
          });
        });
        return kalender;
      },
      formatVonDatum() {
        if (!this.veranstaltung.vonDatum) return null;
        return new Date(this.veranstaltung.vonDatum).toLocaleString(["de-de"], {
          month: "short",
          weekday: "short",
          day: "numeric",
          year: "2-digit",
        });
      },
      formatBisDatum() {
        if (!this.veranstaltung.bisDatum) return null;
        return new Date(this.veranstaltung.bisDatum).toLocaleString(["de-de"], {
          month: "short",
          weekday: "short",
          day: "numeric",
          year: "2-digit",
        });
      },
    },
    methods: {
      allowedMinutes: (m) => m % 5 === 0,
      changeVonDatum() {
        if (!this.veranstaltung.bisDatum) {
          this.veranstaltung.bisDatum = this.veranstaltung.vonDatum;
        }
        if (!this.veranstaltung.bisZeit) {
          this.veranstaltung.bisZeit = "23:55";
        }
        if (!this.veranstaltung.vonZeit) {
          this.veranstaltung.vonZeit = "20:15";
        }
      },
      anmeldungEntfernen(item) {
        this.veranstaltung.anmeldungen.splice(this.veranstaltung.anmeldungen.indexOf(item), 1);
      },
      anmeldungHinzufuegen() {
        if (this.veranstaltung.anmeldungen.indexOf(this.neueAnmeldung) === -1) {
          this.veranstaltung.anmeldungen.push(this.neueAnmeldung);
        }
        this.neueAnmeldung = "";
      },
      anmeldungEntfernenWeitere(item) {
        this.veranstaltung.weitereAnmeldungen.splice(this.veranstaltung.weitereAnmeldungen.indexOf(item), 1);
      },
      anmeldungHinzufuegenWeitere() {
        this.veranstaltung.weitereAnmeldungen.push({
          angemeldetVon: this.neueAnmeldungWeitere.angemeldetVon,
          name: this.neueAnmeldungWeitere.name,
        });
        this.neueAnmeldungWeitere = {};
      },
      saveVeranstaltung() {
        this.$store.dispatch("veranstaltungen/updateVeranstaltungData", this.veranstaltung);
        this.close();
      },
      deleteVeranstaltung() {
        this.$store.dispatch("veranstaltungen/deleteVeranstaltungData", this.veranstaltung.id);
        this.showDeleteVeranstaltung = false;
        this.close();
      },
      close() {
        this.$emit("close", false);
      },
    },
  };
</script>

<style scoped></style>



// WEBPACK FOOTER //
// dialogVeranstaltungEdit.vue?6bcfac0e